import React, { useEffect, useRef } from 'react';

function MobileFooterModal({ children, show, setShow }) {
    const ref = useRef();

    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                // alert("You clicked outside of me!");
                setShow(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, setShow]);

    if (!show) {
        return null;
    }

    return (
        <div className="footer-modal">
            <div className="footer-options" ref={ref}>
                {children}
            </div>
        </div>
    );
}

export default MobileFooterModal;
